import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectCurrentUserPrefersClassicView = createBasicSelector(state =>
  selectBooleanPreferenceByName(state, 'classic_view')
)
